import FarmList from "../../slices/farm/farm/FarmList";
import FarmDetails from "../../slices/farm/farm/FarmDetails";
import FarmCropDailyTasks from "../../slices/farm/farm/FarmCropDailyTasks";
import FarmRoomsList from "../../slices/farm/farm/FarmRoomsList";
import ActiveFarmCrops from "../../slices/farm/farm/ActiveFarmCrops";
import CropByFarm from "../../slices/farm/daily_logs/CropByFarm";
import RoomsByFarm from "../../slices/farm/daily_logs/RoomsByFarm";
import CropsByFarmRoom from "../../slices/farm/daily_logs/CropsByFarmRoom";
import GetDailyLogs from "../../slices/farm/daily_logs/GetDailyLogs";
import ServiceRequestList from "../../slices/farm/service_request/ServiceRequestList";
import ServiceRequestDetails from "../../slices/farm/service_request/ServiceRequestDetails";
import FarmExpenseList from "../../slices/farm/farm_expense/FarmExpenseList";
import FarmExpenseDetails from "../../slices/farm/farm_expense/FarmExpenseDetails";
import FarmDailyLogList from "../../slices/farm/daily_logs/FarmDailyLogList";
import FarmDailyLogView from "../../slices/farm/daily_logs/FarmDailyLogView";

const farmReducer = {
    farmList: FarmList,
    farmDetails: FarmDetails,
    farmCropDailyTasks: FarmCropDailyTasks,
    farmRoomsList: FarmRoomsList,
    activeFarmCrops: ActiveFarmCrops,
    cropByFarm: CropByFarm,
    roomsByFarm: RoomsByFarm,
    cropsByFarmRoom: CropsByFarmRoom,
    getDailyLogs: GetDailyLogs,
    serviceRequestList: ServiceRequestList,
    serviceRequestDetails: ServiceRequestDetails,
    farmExpenseList: FarmExpenseList,
    farmExpenseDetails: FarmExpenseDetails,
    farmDailyLogList: FarmDailyLogList,
    farmDailyLogView: FarmDailyLogView,
};

export default farmReducer;
